import styled from "styled-components";

export const SidebarWrapper = styled.div`
  min-width: 232px;
  position: absolute;
  top: 0px;
  padding: 20px;
  background: #1D3557;
  z-index: 11;
  bottom: 0;
  transition: all .3s;
  ul {
    li {
      background: #4FA0FF;
      border-radius: 10px;
      display: flex;
      gap: 8px;
      align-items: center;
      height: 45px;
      padding: 13px;
      color: #fff;
      margin-bottom: 10px;
      border: 1px solid transparent;
      transition: all .3s;
      span {
        display: block;
        font-size: 15px;
        font-weight: 600;
        width: 100%;
        visibility: visible;
        opacity: 1;
        white-space: nowrap;
      }
      &:hover {
        box-shadow: 0px 4px 15px rgba(79, 160, 255, 0.2);
        border: 1px solid #FFD700;
        transform: translateY(-2px);
      }
      &.active {
        background-color: #FFD700;
        color: #1D3557;
        img {
        }
      }
    }
  }

  &.close {
    min-width: 80px;
    width: 80px;
    overflow: hidden;
    transition: all .3s;
    ul li {
      justify-content: center;
      span {
        visibility: hidden;
        opacity: 0;
        display: none;
      }
    }
    @media only screen and (max-width: 768px) {
      min-width: 232px;
      width: 232px;
      left: -244px;
      overflow: hidden;
      ul li {
        justify-content: start;
        span {
          display: block;
        }
      }
    }
  }
`;